import React from "react";

export default function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div className="flex flex-col items-center justify-center py-12" role="alert" aria-live="assertive">
      <div className="text-6xl mb-4">😢</div>
      <div className="text-lg font-semibold mb-2 text-red-600">{message}</div>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-4 bg-primary-600 text-white px-6 py-2 rounded font-semibold hover:bg-primary-700 transition"
        >
          Retry
        </button>
      )}
    </div>
  );
} 